export function deriveConvexSiteUrl(): string {
  const raw = import.meta.env.VITE_CONVEX_URL as string | undefined;
  if (!raw) return "";
  // Local dev runs cloud:3210 / site:3211 on the same loopback host (see
  // apps/clawcraft/.convex/local/default/config.json). The .cloud→.site
  // substring rule below only fires for prod *.convex.cloud URLs.
  if (/^https?:\/\/(127\.0\.0\.1|localhost):3210(\/|$)/.test(raw)) {
    return raw.replace(":3210", ":3211");
  }
  return raw.replace(".cloud", ".site");
}

export function buildFilePreviewUrl(gcsPath: string): string {
  return `${deriveConvexSiteUrl()}/api/file-url?path=${encodeURIComponent(gcsPath)}`;
}
